import { useDispatch, useSelector } from 'react-redux'
import { open } from '@/store/modalsSlice'
import { OFFERS_MODAL } from '@/common/constants/modals'
import classNames from 'classnames'
import { userAmplitudeAnalytics } from '@/common/services/userAmplitudeAnalytics'
import { ANALYTIC_OFFER } from '@/common/constants/analytics'
import { SUBSCRIPTION_DEMO } from '@/common/constants/payments'

export const CLICK_COUNT_KEY = 'clickCount'
export const OFFER_MODAL_KEY = 'offerModal'
export const MAX_CLICKS_BEFORE_MODAL = 3

const useOffers = (onCardItemClick, media, numberIndex, experimentKey) => {
  const dispatch = useDispatch()
  const subscription = useSelector((store) => store.user.subscription || {})

  const handleCardClick = (e, data) => {
    let clickCount = parseInt(
      sessionStorage.getItem(CLICK_COUNT_KEY) || '0',
      10
    )

    if (numberIndex % 5 === 0 && subscription?.name === SUBSCRIPTION_DEMO) {
      dispatch(open(OFFERS_MODAL))
      userAmplitudeAnalytics.trackEvent(
        `${ANALYTIC_OFFER}_search_banner_shown`,
        { trigger: 'blur' }
      )
      sessionStorage.setItem(OFFER_MODAL_KEY, 'blur')
    } else if (
      clickCount >= MAX_CLICKS_BEFORE_MODAL &&
      subscription?.name === SUBSCRIPTION_DEMO
    ) {
      userAmplitudeAnalytics.trackEvent(
        `${ANALYTIC_OFFER}_search_banner_shown`,
        { trigger: 'details' }
      )
      sessionStorage.setItem(OFFER_MODAL_KEY, 'details')
      dispatch(open(OFFERS_MODAL))
    } else {
      clickCount += 1
      sessionStorage.setItem(CLICK_COUNT_KEY, clickCount.toString())
      onCardItemClick(e, data)
    }
  }

  const isExperiment = subscription?.name === SUBSCRIPTION_DEMO

  const cardClasses = classNames({
    isBlurred: numberIndex % 5 === 0 && isExperiment,
    'hover-experiment': experimentKey === 'frame',
  })

  return { handleCardClick, cardClasses }
}

export default useOffers
